package org.catharsis.spendtel.feature.presentation.expensereport

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Image
import androidx.compose.material.icons.outlined.Link
import androidx.compose.material.icons.outlined.Share
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.catharsis.spendtel.feature.share.ShareCardContent
import org.catharsis.spendtel.feature.share.ShareImageCard

val LocalExpenseReportShareHandler = staticCompositionLocalOf<((ShareCardContent) -> Unit)?> { null }
val LocalExpenseReportShareImageHandler = staticCompositionLocalOf<((ShareImageCard) -> Unit)?> { null }

@Composable
fun ProvideExpenseReportShareHandlers(
    onShareText: (ShareCardContent) -> Unit,
    onShareImage: (ShareImageCard) -> Unit,
    content: @Composable () -> Unit,
) {
    CompositionLocalProvider(
        LocalExpenseReportShareHandler provides onShareText,
        LocalExpenseReportShareImageHandler provides onShareImage,
        content = content,
    )
}

@Composable
fun ExpenseReportShareIconButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    contentDescription: String = "Share",
) {
    IconButton(onClick = onClick, modifier = modifier) {
        Icon(
            imageVector = Icons.Outlined.Share,
            contentDescription = contentDescription,
        )
    }
}

@Composable
fun ReportShareActions(
    onShareText: () -> Unit,
    onShareImage: (() -> Unit)? = null,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(2.dp),
    ) {
        ExpenseReportShareIconButton(onClick = onShareText)
        if (onShareImage != null) {
            IconButton(onClick = onShareImage) {
                Icon(
                    imageVector = Icons.Outlined.Image,
                    contentDescription = "Share image",
                )
            }
        }
    }
}

@Composable
fun ShareCardActions(
    content: ShareCardContent,
    imageCard: ShareImageCard? = null,
    modifier: Modifier = Modifier,
) {
    val shareText = LocalExpenseReportShareHandler.current ?: return
    val shareImage = LocalExpenseReportShareImageHandler.current

    ReportShareActions(
        modifier = modifier,
        onShareText = { shareText(content) },
        onShareImage = imageCard?.let { card ->
            shareImage?.let { handler -> { handler(card) } }
        },
    )
}

@Composable
fun ShareLinkButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    label: String = "Copy link",
) {
    TextButton(onClick = onClick, modifier = modifier) {
        Icon(
            imageVector = Icons.Outlined.Link,
            contentDescription = null,
        )
        Text(text = label, style = MaterialTheme.typography.labelLarge)
    }
}
